import React from 'react';
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import { getTokenExp } from "./helpers/helpers";
import './App.scss';

import LoginPage from "./components/LoginPage";
import TermsAndConditions from "./components/TermsAndConditions";
import TermsAndConditionsAgronetPlus from "./components/TermsAndConditionsAgronetPlus";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PrivacyPolicyPl from "./components/PrivacyPolicyPl";
import PrivacyPolicyAgronetPlus from "./components/PrivacyPolicyAgronetPlus";
import MainPage from "./components/_layout/MainPage";
import AppMeasurements from "./components/AppMeasurements/AppMeasurements";
import AppCharts from "./components/AppMeasurements/AppCharts";
import ShareMail from "./components/ShareMail/ShareMail";
import AppSensorConfiguration from "./components/AppMeasurements/AppSensorConfiguration";
import IframeDetailsModal from "./components/IframeDetailsModal";
import ResponsiveSignup from "./components/ResponsiveSignup/ResponsiveSignup";

const PrivateRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={(props) => (
        (sessionStorage.getItem('agronetToken') && (getTokenExp() > Date.now() / 1000))
            ? <Component {...props}/>
            : <Redirect to='/start'/>
    )}/>
);

const App = () => {

    return (
        <BrowserRouter>
            <Switch>
                <Route
                    exact path='/start*'
                    render={props =>
                        <LoginPage
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/terms_and_conditions'
                    render={props =>
                        <TermsAndConditions
                            {...props}
                            backButton
                        />
                    }
                />
                <Route
                    exact path='/privacy_policy'
                    render={props =>
                        <PrivacyPolicy
                            {...props}
                            backButton
                        />
                    }
                />
                <Route
                    exact path='/terms_and_conditions_agronet_plus'
                    component={TermsAndConditionsAgronetPlus}
                />
                <Route
                    exact path='/terms_and_conditions_app'
                    render={props =>
                        <TermsAndConditions
                            {...props}
                        />
                    }
                />
                <Route
                    exact path={['/privacy_policy_agronet_plus', '/privacy_policy_agronet_plus_pl']}
                    component={PrivacyPolicyAgronetPlus}
                />
                <Route
                    exact path='/privacy_policy_app'
                    render={props =>
                        <PrivacyPolicy
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/privacy_policy_app_pl'
                    render={props =>
                        <PrivacyPolicyPl
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/share_mail'
                    render={props =>
                        <ShareMail
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/signup_mobile'
                    render={props =>
                        <ResponsiveSignup
                            {...props}
                        />
                    }
                />
                {/*<Route*/}
                {/*    path='/sensor_details*'*/}
                {/*    render={props =>*/}
                {/*        <AppMeasurements*/}
                {/*            {...props}*/}
                {/*        />*/}
                {/*    }*/}
                {/*/>*/}
                {/*<Route*/}
                {/*    path='/measurements*'*/}
                {/*    render={props =>*/}
                {/*        <AppMeasurements*/}
                {/*            {...props}*/}
                {/*        />*/}
                {/*    }*/}
                {/*/>*/}
                {/*<Route*/}
                {/*    path='/sensor_details*'*/}
                {/*    render={props =>*/}
                {/*        <AppCharts*/}
                {/*            {...props}*/}
                {/*        />*/}
                {/*    }*/}
                {/*/>*/}
                <Route
                    path='/iframe_details*'
                    render={props =>
                        <IframeDetailsModal
                            {...props}
                        />
                    }
                />
                <Route
                    path='/sensor_details*'
                    render={props =>
                        <AppSensorConfiguration
                            {...props}
                        />
                    }
                />
                <PrivateRoute
                    path='/'
                    component={props =>
                        <MainPage
                            {...props}
                        />
                    }
                />
            </Switch>
        </BrowserRouter>
    );
};

export default App;
